import { ReactNode } from 'react'
import { IXrayManualConfirmation } from 'types'

export const XRAY_MANUAL_CONFIRMATIONS: ReadonlyArray<{
  id: IXrayManualConfirmation
  label: ReactNode
}> = [
  {
    id: 'manual_read',
    label:
      'Li o manual, estou ciente de como a ferramenta funciona e sei buscar informações adicionais se necessário.'
  }
]
